import React from "react";
import styled from "styled-components";

import {
  AdminSection,
  AdminSectionBadge,
  AdminSectionHeader,
} from "../section_engine";


function displayValue(value) {
  if (
    typeof value === "string"
    && value.trim()
  ) {
    return value.trim();
  }

  return "Non renseigné";
}


export default function EmployeeOrganizationSection({
  organization,
}) {
  const establishment =
    organization?.establishment ?? null;

  const department =
    organization?.department ?? null;

  const position =
    organization?.position ?? null;

  const manager =
    organization?.manager ?? null;

  return (
    <AdminSection
      aria-labelledby={
        "employee-organization-title"
      }
    >
      <AdminSectionHeader>
        <AdminSectionBadge>
          Organization
        </AdminSectionBadge>

        <h2
          id="employee-organization-title"
        >
          Organisation
        </h2>

        <p>
          Projection read-only de l'organisation
          courante résolue par le backend.
        </p>
      </AdminSectionHeader>

      <OrganizationGrid>
        <OrganizationItem>
          <dt>Établissement</dt>
          <dd>
            {displayValue(
              establishment?.name,
            )}
          </dd>
        </OrganizationItem>

        <OrganizationItem>
          <dt>Département</dt>
          <dd>
            {displayValue(
              department?.name,
            )}
          </dd>
        </OrganizationItem>

        <OrganizationItem>
          <dt>Poste</dt>
          <dd>
            {displayValue(
              position?.name,
            )}
          </dd>
        </OrganizationItem>

        <OrganizationItem>
          <dt>Manager</dt>
          <dd>
            {displayValue(
              manager?.name,
            )}
          </dd>
        </OrganizationItem>
      </OrganizationGrid>
    </AdminSection>
  );
}


const OrganizationGrid = styled.dl`
  display: grid;

  grid-template-columns:
    repeat(
      auto-fit,
      minmax(190px, 1fr)
    );

  gap: 0.8rem;

  margin: 0;
`;


const OrganizationItem = styled.div`
  min-width: 0;

  padding: 0.75rem;

  border:
    1px solid
    rgba(255, 255, 255, 0.08);

  border-radius: 14px;

  background:
    rgba(11, 19, 40, 0.24);

  dt {
    margin-bottom: 0.35rem;

    color:
      rgba(247, 247, 247, 0.62);

    font-size: 0.76rem;
    font-weight: 700;

    letter-spacing: 0.03em;
    text-transform: uppercase;
  }

  dd {
    margin: 0;

    color: #fff9ea;

    font-size: 0.94rem;
    font-weight: 700;

    overflow-wrap: anywhere;
  }
`;
